'use strict';
// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('PropriedadesService', function($http, OperacoesService, MessagesService) {
  return {
    defaultParams: {
      bounds: true
    },

    list: function() {
      return $http.get(`${SERVER + API_VERSION }propriedades`, {
        params: this.defaultParams
      });
    },

    get: function(id, params = null) {
      return $http.get(`${SERVER + API_VERSION }propriedades/${id}`, {
        params
      });
    },

    save: function(propriedade) {
      return $http({
        method: propriedade.id ? 'PATCH' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER + API_VERSION }propriedades/${ propriedade.id || ''}`,
        data: {
          propriedade: {
            descricao: propriedade.descricao,
            cd_cidade: _.get(propriedade, 'cidade.codigo'),
            hash_objeto: propriedade.hash_objeto
          }
        }
      });
    },

    inactivate: function(id) {
      return $http.post(`${SERVER}${API_VERSION }propriedades/${id}/inactivate`);
    },

    activate: function(id) {
      return $http.post(`${SERVER}${API_VERSION }propriedades/${id}/activate`);
    },

    all: function(status, depositoId) {
      return $http.get(`${SERVER}${API_VERSION }propriedades/all`, {
        params: {
          status: status,
          cd_deposito: depositoId
        }
      });
    },

    summary: function(filters) {
      const _this = this;

      return OperacoesService.resumoGlebas(filters).then(function(result) {
        return result.data.map(_this.processItem);
      //eslint-disable-next-line
      }).catch(function(error) {
        console.error('Erro ao carregar resumo', error);
        MessagesService.alert('Falha ao consultar resumo geral dos talhões');
      });
    },

    activities: function(params) {
      const _this = this;

      return OperacoesService.getHistoryGlebaV2(params).then(function(result) {
        return result.data.map(_this.processItem);
      //eslint-disable-next-line
      }).catch(function(error) {
        console.error('Erro ao carregar históricos/atividades', error);
        MessagesService.alert('Falha ao consultar dados do dia');
      });
    },

    activitiesPaginated: function(params) {
      const _this = this;

      return OperacoesService.getHistoryGlebaV2Paginated(params).then(function(result) {
        result.data = result.data.map(_this.processItem);
        return result;
      });
    },

    processItem: function(item) {
      if (item.notificacoes && item.notificacoes.length > 1) {
        item.notificacoes = item.notificacoes.filter(function(notification) {
          return notification.tipo !== 'caminhamento';
        });
        item.notificacoes = _.uniqBy(item.notificacoes, JSON.stringify);
      }

      if (item.gerais.stand && item.gerais.stand.length === 1) {
        item.stand = item.gerais.stand[0];
        item.stand.active = false;
      } else {
        item.stand = null;
      }

      if (item.gerais.produtividade && item.gerais.produtividade.length === 1) {
        item.productivity = item.gerais.produtividade[0];
        item.productivity.active = false;
      } else {
        item.productivity = null;
      }

      return item;
    }
  };
});
